<script setup lang="ts">
import { showLogoutDialogue } from "@/components/Dialogues/useData/useDialogues";
import login from "@/../CsdPublic/login";

import publicStore from "@/store/publicStore";
import { storeToRefs } from "pinia";

const { isLogin } = storeToRefs(publicStore());
const onLogout = () => {
  showLogoutDialogue.value = false;
  login.logOut();
  isLogin.value = false;
};
</script>

<template>
  <el-dialog
    v-model="showLogoutDialogue"
    width="240"
    class="custom-dialog"
    align-center
    :show-close="false"
    title="提示"
    center
    :style="{ '--el-border-radius-base': '16px' }"
  >
    <div class="body">是否确认退出登录？</div>

    <template v-slot:footer>
      <div class="footer">
        <el-button class="cancel-btn" plain @click="showLogoutDialogue = false">
          取消
        </el-button>
        <el-button class="ok-btn" type="primary" @click="onLogout">
          确定
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<style lang="scss" scoped>
.custom-dialog {
  :deep(.el-dialog__header) {
    display: none !important;
  }
  .el-dialog__header {
    display: none !important;
  }

  .body {
    text-align: center;
  }
}

.custom-dialog .el-dialog__header {
  display: none;
}

.footer {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .cancel-btn {
    width: 50%;
    color: #4d6bfe;
    border-radius: 8px;
  }
  .ok-btn {
    border-radius: 8px;
    border: 0px solid #4d6bfe;
    width: 50%;
    color: #fff;
    background-color: #4d6bfe;

    &:hover {
      background-color: #4d6bfe99;
    }
  }
}
</style>
